<template lang="pug">
  .afterpay-messaging-container
    .adjacent(:id="id")
</template>

<script>
  export default {

    name: 'AfterpayMessaging',

    props: {
      amount: {
        type: Number,
        required: true,
      },

      recurring: {
        type: Boolean,
        default: false,
      },

      size: {
        type: String,
        default: 'xs',
      },

      introText: {
        type: String,
        default: undefined,
      },

      logoType: {
        type: String,
        default: undefined,
      },

      showWith: {
        type: Boolean,
        default: true,
      },
    },

    data: () => ({
      id: null,
    }),

    watch: {
      amount() {
        this.reloadAfterpayTag();
      },

      size() {
        this.reloadAfterpayTag();
      },

      recurring() {
        this.reloadAfterpayTag();
      },
    },

    mounted() {
      // need an unique id
      this.id = `afterpay-${this._uid}-${(new Date()).getTime()}`;

      this.$nextTick(() => {
        window.addEventListener('Afterpay.ready', () => {
          this.reloadAfterpayTag();
        });
        this.reloadAfterpayTag();
      });
    },

    methods: {
      reloadAfterpayTag() {
        if (!window.Afterpay) {
          return;
        }

        const currentElement = document.getElementById(this.id);
        if (currentElement && currentElement.nextElementSibling) {
          currentElement.nextElementSibling.remove();
        }

        const attributes = {
          size: this.size,
          amount: this.amount,
          locale: 'en_US',
          currency: 'USD',
          badgeTheme: 'white-on-black',
          introText: this.introText,
          modalTheme: 'white',
          logoType: this.logoType,
          showWith: this.showWith,
          modalId:'en_US-mr',
        };

        if (this.recurring) {
          attributes.type = "recurring-instalments";
        }

        window.Afterpay.createPlacements({
          targetSelector: `#${this.id}`,
          attributes
        });
      },
    },
  };
</script>

<style lang="stylus">
  .afterpay-messaging-container
    text-align center

    afterpay-placement
      --logo-badge-width 80px

    @media mq-mobile
      .afterpay-paragraph
        font-size 10px !important

      afterpay-placement
        --logo-badge-width 65px

</style>